import axios from 'axios';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content');

class SearchFilter {
    async fetchCity(city: number) {
        const resp = await axios({
            url: '/location/areas?',
            params: { city: city },
            method: 'get'
        });

        return resp.data;
    }

    async fetchStreet(city: number, only: boolean, query: string, page: number) {
        const resp = await axios({
            url: '/location/map?entity=street',
            params: { city: city, query: query, page: page, onlyRootCity: only === undefined ? true : only },
            method: 'get',
        });

        return resp.data.response;
    }

    async fetchHouses(street: number) {
        const resp = await axios({
            url: '/location/map?entity=house&limit=0',
            params: { street: street },
            method: 'get'
        });

        return resp.data.response.objects;
    }

    async fetchSearch(url: string, streetId: Array<number>|null, houseId: Array<number>|null, areaId: Array<number>|null) {
        const resp = await axios.post(url, {houses_ids: houseId, streets_ids: streetId, area_ids: areaId});

        return resp.data;
    }
}

const apiSearchFilter = new SearchFilter();
export { apiSearchFilter };
